module.exports = __webpack_public_path__ + "fonts/icomoon.9450591.woff";